import { useMemo } from 'react';
import {
  findUnsupportedVariablesForGeneralAutomation,
  findUnsupportedVariablesForReferenceCheck,
  sanitizeVariableName,
} from 'features/Automations/utils/emailTemplateValidation';
import { EmailTemplate } from 'components/ReferenceModal/types';

export type ValidationMode = 'general' | 'reference';

export function useEmailTemplateValidation(
  selectedEmailTemplate: EmailTemplate | undefined,
  mode: ValidationMode,
  maxDisplayCount: number = 5
) {
  const unsupportedVariables = useMemo(() => {
    return mode === 'reference'
      ? findUnsupportedVariablesForReferenceCheck(selectedEmailTemplate)
      : findUnsupportedVariablesForGeneralAutomation(selectedEmailTemplate);
  }, [selectedEmailTemplate, mode]);

  const hasUnsupportedVariables = unsupportedVariables.length > 0;

  const sanitizedUnsupportedVariables = useMemo(
    () => unsupportedVariables.map(sanitizeVariableName),
    [unsupportedVariables]
  );

  const displayedVariables = useMemo(() => {
    if (sanitizedUnsupportedVariables.length > maxDisplayCount) {
      const displayed = sanitizedUnsupportedVariables.slice(0, maxDisplayCount);
      const remaining = sanitizedUnsupportedVariables.length - maxDisplayCount;
      return `${displayed.join(', ')} and ${remaining} more`;
    }
    return sanitizedUnsupportedVariables.join(', ');
  }, [sanitizedUnsupportedVariables, maxDisplayCount]);

  return {
    unsupportedVariables,
    sanitizedUnsupportedVariables,
    displayedVariables,
    hasUnsupportedVariables,
  };
}
